// Send notifications to users via Worker API
// Pass a `context` object ({ type, title, description, category, url, whatItMeans })
// to have Claude generate the notification message automatically.
const WORKER_BASE = "https://content-parser-admin-api.saas-c79.workers.dev";

export const sendNotification = async (title, message, linkType = null, linkId = null, context = null) => {
  let finalMessage = message;

  if (context) {
    try {
      const aiResp = await fetch(`${WORKER_BASE}/api/generate-notification`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(context)
      });
      if (aiResp.ok) {
        const data = await aiResp.json();
        if (data.message) finalMessage = data.message;
      }
    } catch (err) {
      console.warn("⚠️ Could not generate AI notification message, using fallback:", err.message);
    }
  }

  try {
    console.log("📤 Sending notification:", title);

    const response = await fetch(`${WORKER_BASE}/api/notify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        title,
        message: finalMessage,
        link_type: linkType,
        link_id: linkId,
        status: "pending"
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.warn(`❌ Notification failed: ${response.status}`, errorText);
      return false;
    }

    const result = await response.json();
    console.log("✓ Notification logged:", title, result);
    return true;
  } catch (err) {
    console.warn("⚠️ Could not send notification:", err.message);
    return false;
  }
};
